import "./Page.css";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import Header from "../app/Header";
import Sidebar from "../app/Sidebar";
import All from "./All";
import Edit from "./Edit";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";

import { Container, Row, Col } from "reactstrap";

import Match from "../components/Match";

import { Miss } from "react-router";
import NotFound from "../notfound/NotFoundPage";

class Page extends React.Component {
  constructor() {
    super();
  }

  redirect(to) {
    const { router } = this.context;
    if (router) router.transitionTo(to);
  }

  render() {
    const { map, results, meta, pathname, location } = this.props;
    return (
      <div className="data-page application-page">
        <Helmet title={"Aplikacje"} />
        <Header title="Aplikacje" />

        <div className="page">
          <div className="sidebar-wrapper">
            <Sidebar />
          </div>

          <div className="content">
            <Container>
              <Row>
                <Col xs="12">
                  <Breadcrumbs location={location} />
                  <Match
                    authorized
                    pattern={`${pathname}/edit/:uid`}
                    component={Edit}
                  />
                  <Match
                    authorized
                    exactly
                    pattern={pathname}
                    component={All}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(state => ({}), {})(Page);



// WEBPACK FOOTER //
// ./src/browser/application/Page.js